/* eslint-disable react/jsx-props-no-spreading */
// montant_de_couverture
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { get, isArray } from 'lodash-es';

import CurrencyFieldMU from '../../Common/CurrencyFieldMU';
import Select from '../../Common/Select';

class CoverageAmount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: '',
    };
  }

  render() {
    const { strings, data, values, ...props } = this.props;
    const { disabled } = props;
    const { selectedValue } = this.state;

    if (data && data.coverageAmount && isArray(data.coverageAmount)) {
      const options = data.coverageAmount.map(option => ({ text: option[1], value: option[0] }));
      return (
        <Select
          className="field select"
          key="coverage_amount"
          field="coverage_amount"
          id="select-coverage_amount"
          name="coverage_amount"
          shrink
          label={strings['block.loan.field.coverageAmount.label'] || 'Montant de couverture'}
          options={options}
          onChange={value => this.setState({ selectedValue: value })}
          value={selectedValue}
          initialValue={get(values, 'coverage_amount')}
          required
          disabled={disabled}
        />
      );
    }

    return (
      <CurrencyFieldMU
        {...props}
        key="coverage_amount"
        field="coverage_amount"
        id="coverage_amount"
        name="coverage_amount"
        label={strings['block.loan.field.coverageAmount.label'] || 'Montant de couverture'}
        placeholder=""
        required
        shrink
        onChange={value => this.setState({ selectedValue: value })}
        value={selectedValue}
      />
    );
  }
}

CoverageAmount.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string).isRequired,
  key: PropTypes.string,
  field: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  shrink: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.number,
  data: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  values: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

CoverageAmount.defaultProps = {
  placeholder: 'Montant de couverture',
  required: true,
  disabled: false,
  shrink: true,
  key: 'coverage_amount',
  field: 'coverage_amount',
  id: 'coverage_amount',
  name: 'coverage_amount',
  label: 'Montant de couverture',
  onChange: undefined,
  value: undefined,
  data: undefined,
  values: {},
};

export default CoverageAmount;
